<div class="min-h-screen bg-[#fafafa] flex flex-col">
    <app-header></app-header>
    <main class="grow flex flex-col">
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
</div>